/* global axios */
import ApiClient from './ApiClient';

class AceleresTeamPresenceAPI extends ApiClient {
  constructor() {
    super('aceleres/team_presence', { accountScoped: true });
  }

  // Lista vendedores por equipes, com rodizio habilitado por padrao.
  getPresence({ teamIds, includeOutOfRotation = false } = {}) {
    const params = { include_out_of_rotation: includeOutOfRotation };
    if (teamIds !== undefined) params.team_ids = teamIds;

    return axios.get(this.url, {
      params,
    });
  }

  getHistory({ from, to } = {}) {
    return axios.get(`${this.url}/history`, {
      params: { from, to },
    });
  }

  // Registra atividade real (input) do usuario logado.
  activityPing() {
    return axios.post(`${this.url}/activity_ping`);
  }

  // Liga/desliga a participacao do vendedor no rodizio. Ao desligar pode
  // redistribuir as conversas abertas/pendentes: redistribute 'specific'|'equal'|'none'.
  // Vincula o ID do consultor no Salesforce ao agente (so gestor/administrator).
  setSalesforceId({ userId, salesforceId }) {
    return axios.post(`${this.url}/set_salesforce_id`, {
      user_id: userId,
      salesforce_id: salesforceId,
    });
  }

  setRodizio({ userId, enabled, redistribute = 'none', targetId = null }) {

    return axios.post(`${this.url}/set_rodizio`, {
      user_id: userId,
      enabled,
      redistribute,
      target_id: targetId,
    });
  }

  // Botão "Iniciar": trava a conversa no rodizio (rodizio_locked=true) + garante
  // assignee = atendente que clicou. Move a conversa de NOVOS pra MEUS.
  lockConversation({ conversationDisplayId }) {
    return axios.post(`${this.url}/lock_conversation`, {
      conversation_display_id: conversationDisplayId,
    });
  }
}

export default new AceleresTeamPresenceAPI();
